import { jwtDecode } from 'jwt-decode';
import { useLocation } from 'react-router-dom';

export const useGetPurseRedirectionData = () => {
  const { search } = useLocation();
  const purseRedirectionData = new URLSearchParams(search).get(
    'purse-redirection-data',
  ) as string;

  const { client_session_id } = purseRedirectionData
    ? jwtDecode<{
        client_session_status?: string;
        client_session_id?: string;
        payment_id?: string;
        authorization_status?: string;
      }>(purseRedirectionData)
    : { client_session_id: undefined };

  return {
    clientSessionId: client_session_id,
  };
};
